import { Tradable } from "../../interfaces/tradable";
import { DERIVATIVE_TYPE } from "@helpers/constants";

export abstract class Derivative extends Tradable {
	protected static readonly currencyType: string = DERIVATIVE_TYPE;

	protected isin: string = "";
	protected readonly tradable_actions: string[] = ["buy", "sell", "swap", "savings"];

	public getCurrencyType(): string {
		return Derivative.currencyType;
	}

	public getPrecision(): number {
		return this.precision_for_coins;
	}

	public isTransferActive(): boolean {
		return false;
	}

	public isWithdrawActive(): boolean {
		return false;
	}

	public isDepositActive(): boolean {
		return false;
	}

	public isHodlTradable(type: string): boolean {
		return false;
	}

	public isIota(): boolean {
		return false;
	}

	public isStellar(): boolean {
		return false;
	}

	public isDerivative(): boolean {
		return true;
	}

	public isRealSecurities(): boolean {
		return false;
	}

	public getIsin(): string {
		return this.isin;
	}
}
